import * as React from 'react';
import * as classNames from "classnames";
import User from "../../../model/user/User";
import {PartnerBrandSearch} from "../../../model/partnerBrand/PartnerBrand";
import Loading from "../../ui/loading/Loading";

interface ComponentProps {
	/**
	 * Organisation user.
	 */
	user: User;
	/**
	 * Partner brands.
	 */
	partnerBrands: { [key: string]: PartnerBrandSearch };
	/**
	 * Row click callback
	 */
	onClick: (user: User) => void;
}

type Props = ComponentProps;

export default class OrganisationUsersTableRow extends React.Component<Props, {}> {

	render() {
		const classes = classNames({"is-disabled": this.props.user.disabled});
		return (
			<tr onClick={() => this.props.onClick(this.props.user)} className={classes}>
				<td>{this.props.user.id}</td>
				<td>{this.props.user.data.firstName}</td>
				<td>{this.props.user.data.lastName}</td>
				<td>{this.props.user.data.username}</td>
				<td>{this.displayPartnerBrand()}</td>
				<td style={{whiteSpace: 'normal'}}>{this.props.user.data.roles.map(
					(role, index) => <span className="d-block" key={index}>{role}</span>)}</td>
				<td>{this.props.user.disabled ? "Disabled" : "Enabled"}
				</td>
			</tr>
		);
	}

	displayPartnerBrand(): JSX.Element {
		const partnerBrand = this.props.partnerBrands[this.props.user.data.partnerBrandId.orNull];
		if (partnerBrand) {
			return <span>{partnerBrand.name}</span>;
		}
		else if (this.props.user.data.partnerBrandId.isDefined && this.props.partnerBrands.isDefined) {
			return <span className="has-error">Partner brand doesn't exist</span>;
		}
		else if (this.props.user.data.partnerBrandId.isDefined) {
			return <Loading isLoading={true} spinnerSize={24}/>
		}
		else {
			return <span/>;
		}
	}
}